<template>
  <v-container fluid>
      <v-row class="mt-4">
        <v-col xl="4" lg="4" sm="12" xs="12">
          <v-row>
            <template v-if="isBiggerThanMd">
              <v-col xl="4" lg="4" sm="12" xs="12" align="center">
                <v-list-item class="justify-center px-2">
                  <v-avatar size="128">
                    <v-img :src="icon" alt="icon" max-height="140" max-width="140"></v-img>
                  </v-avatar>
                </v-list-item>
              </v-col>
              <v-col xl="8" lg="8" sm="12" xs="12">
                <v-row>
                  <v-col cols="3">
                    <div class="text-center" color="#EDEDED">
                      <span style="font-size: 0.8em;" class="grey--text mb-2">年齢</span>
                      <h6 class="font-weight-bold" v-if="user.age !== null">{{ user.age }}才</h6>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <div class="text-center" color="#EDEDED">
                      <span style="font-size: 0.8em;" class="grey--text mb-2">性別</span>
                      <h6 class="font-weight-bold">{{ convertGender(user.gender) }}</h6>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="text-center" color="#EDEDED">
                      <span style="font-size: 0.8em;" class="grey--text mb-2">居住地</span>
                      <h6 class="font-weight-bold">{{ user.prefecture }}</h6>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="text-center" color="#EDEDED">
                      <span style="font-size: 0.8em;" class="grey--text mb-2">エンジニア歴</span>
                      <h6 class="font-weight-bold" v-if="user.career !== null">{{ user.career }}年</h6>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                    <div class="text-left ml-4" color="#EDEDED">
                      <span style="font-size: 0.8em;" class="grey--text mb-2">好きな技術</span>
                      <h6 class="font-weight-bold">{{ user.favorite_technology }}</h6>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </template>
            <template v-else>
            <v-col xl="12" lg="12" sm="12" xs="12" align="center">
              <v-card>
                <v-avatar size="128" class="mt-4">
                  <v-img :src="icon" alt="icon" max-height="140" max-width="140"></v-img>
                </v-avatar>
                <v-divider class="mt-4"></v-divider>
                <v-card-text class="mt-0 overflow-auto">
                  <v-row>
                    <v-col cols="3">
                      <div class="text-center" color="#EDEDED">
                        <span style="font-size: 0.8em;" class="grey--text mb-2">年齢</span>
                        <h6 class="font-weight-bold" v-if="user.age !== null">{{ user.age }}才</h6>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="text-center" color="#EDEDED">
                        <span style="font-size: 0.8em;" class="grey--text mb-2">性別</span>
                        <h6 class="font-weight-bold">{{ convertGender(user.gender) }}</h6>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="text-center" color="#EDEDED">
                        <span style="font-size: 0.8em;" class="grey--text mb-2">居住地</span>
                        <h6 class="font-weight-bold">{{ user.prefecture }}</h6>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div class="text-center" color="#EDEDED">
                        <span style="font-size: 0.8em;" class="grey--text mb-2">エンジニア歴</span>
                        <h6 class="font-weight-bold" v-if="user.career !== null">{{ user.career }}年</h6>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text class="pt-0">
                  <v-row>
                    <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                      <div class="text-left ml-4" color="#EDEDED">
                        <span style="font-size: 0.8em;" class="grey--text mb-2">好きな技術</span>
                        <h6 class="font-weight-bold">{{ user.favorite_technology }}</h6>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            </template>
          </v-row>
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <v-row>
                <span class="ml-2 font-weight-bold">公開リンク：</span>
              </v-row>
              <v-row class="ml-0" justify="start">
                <v-col xl="4" lg="4" md="12" sm="12" xs="12" align="left" class="d-flex align-center">
                  <a v-bind:href="user.github_url" style="text-decoration: none;" target="_blank">
                    <v-avatar size="70" class="mr-4">
                      <a :href="user.github_url" target="_blank"><v-img src="../../assets/github_icon.svg" alt="icon" max-height="70" max-width="70"></v-img></a>
                    </v-avatar>
                  </a>
                  <template v-if="!isBiggerThanMd">
                    <a v-bind:href="user.github_url" style="text-decoration: none;" target="_blank">
                      <span class="text-align-center font-weight-bold">{{ user.github_url }}</span>
                    </a>
                  </template>
                </v-col>
                <v-col xl="4" lg="4" md="12" sm="12" xs="12" align="left" class="d-flex align-center">
                  <a :href="user.twitter_url" style="text-decoration: none;" target="_blank">
                    <v-avatar size="70" class="mr-4">
                      <v-img src="../../assets/twitter_icon.svg" alt="icon" max-height="70" max-width="70"></v-img>
                    </v-avatar>
                  </a>
                  <template v-if="!isBiggerThanMd">
                    <a :href="user.twitter_url" style="text-decoration: none;" target="_blank">
                      <span class="text-align-center font-weight-bold">{{ user.twitter_url }}</span>
                    </a>
                  </template>
                </v-col>
                <v-col xl="4" lg="4" md="12" sm="12" xs="12" align="left" class="d-flex align-center">
                  <a :href="user.other_url" style="text-decoration: none;" target="_blank">
                    <v-avatar size="70" class="mr-4">
                      <v-img src="../../assets/link_icon.svg" alt="icon" max-height="70" max-width="70"></v-img>
                    </v-avatar>
                  </a>
                  <template v-if="!isBiggerThanMd">
                    <a :href="user.other_url" style="text-decoration: none;" target="_blank">
                      <span class="text-align-center font-weight-bold">{{ user.other_url }}</span>
                    </a>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <v-row>
                <span class="ml-2 font-weight-bold">自己紹介：</span>
              </v-row>
              <v-row class="mt-8">
                <v-card width="100%" class="justify-center mr-3" color="#FFFFFF">
                  <v-card-title class="ml-4" style="white-space:pre-wrap;">{{ user.introduction_text }}</v-card-title>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col xl="3" lg="3" md="12" sm="12" xs="12">
          <v-row class="mb-4" :class="{'md-layout': isBiggerThanMd}">
            <v-col cols="12" xl="12" lg="12" sm="12" xs="12">
              <span class="font-weight-bold" style="width:600px">概要：</span>
            </v-col>
          </v-row>
          <v-row class="mb-16">
            <v-col xl="6" lg="6" sm="12" xs="12">
              <v-row justify="center" class="mb-4">
                <span class="font-weight-bold pt-1" style="font-size:8pt;">投稿</span><span class="font-weight-bold">トピック数</span>
              </v-row>
              <v-row justify="center" class="mb-2">
                <v-card width="156" height="70" class="justify-center" color="#C388FF">
                  <v-card-title class="text-h4 font-weight-bold justify-center">{{userPR.topic_count}}件</v-card-title>
                </v-card>
              </v-row>
            </v-col>
            <v-col xl="6" lg="6" sm="12" xs="12">
              <v-row justify="center" class="mb-4">
                <span class="font-weight-bold pt-1" style="font-size:8pt;">お気に入り</span><span class="font-weight-bold">トピック数</span>
              </v-row>
              <v-row justify="center" class="mb-2">
                <v-card width="156" height="70" class="justify-center" color="#C388FF">
                  <v-card-title class="text-h4 font-weight-bold justify-center">{{userPR.favorite_topic_count}}件</v-card-title>
                </v-card>
              </v-row>
            </v-col>
            <v-col xl="6" lg="12" sm="12" xs="12">
              <v-row justify="center" class="mb-4">
                <span class="font-weight-bold pt-1" style="font-size:8pt;">お気に入り</span><span class="font-weight-bold">ユーザー数</span>
              </v-row>
              <v-row justify="center" class="mb-2">
                <v-card width="156" height="70" class="text-center" color="#C388FF">
                  <v-card-title class="text-h4 font-weight-bold justify-center">{{userPR.favorite_user_count}}件</v-card-title>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="mb-8"></v-divider>
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <span class="font-weight-bold">性格：</span>
              <div class="mt-4" style="backgroundColor: #FAFAFA; min-width: 320px;">
                <RadarChart :chartData="userPR.user_characters" :characterTypes="characterTypes" />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col xl="5" lg="5" sm="12" xs="12">
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <span class="ml-2 font-weight-bold">得意とするスキル：</span>
              <div class="mt-4" style="backgroundColor: #FAFAFA; min-width: 320px;">
                <BarChart :chartData="userPR.user_languages" :languageTypes="languageTypes" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="12" xs="12">
              <span class="ml-2 font-weight-bold">得意とするツール：</span>
              <div class="mt-4" style="backgroundColor: #FAFAFA; min-width: 320px;">
                <PieChart :chartData="userPR.user_tools" :toolTypes="toolTypes" />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
  </v-container>
</template>
<script>
import RadarChart from '../molecules/RadarChart.vue';
import BarChart from '../molecules/BarChart.vue';
import PieChart from '../molecules/PieChart.vue';

export default {
  name: 'UserInfo',
  components: {
    RadarChart,
    BarChart,
    PieChart,
  },
  props: [
    'user',
    'userPR',
  ],
  data() {
    return {
      gender: {
        man: '男性',
        woman: '女性',
      },
      characterTypes: [],
      languageTypes: [],
      toolTypes: [],
    }
  },
  computed: {
    icon: function() {
      return this.user.icon_url
    },
    isBiggerThanMd() {
      let isBigger = true;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          isBigger = false;
          break;
        case 'sm':
          isBigger = false;
          break;
        case 'md':
          isBigger = false;
          break;
        case 'lg':
          isBigger = true;
          break;
        case 'xl':
          isBigger = true;
          break;
        default:
          break;
      }
      return isBigger;
    }
  },
  methods: {
    convertGender: function(type) {
      return this.gender[type]
    }
  },
  created() {
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/characters')
      .then(response => {
        this.characterTypes = response.data;
      });
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/technologies?category=lang')
      .then(response => {
        this.languageTypes = response.data;
      });
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/technologies?category=tool')
      .then(response => {
        this.toolTypes = response.data;
      });
  }
};
</script>
<style scoped>
.md-layout {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
</style>